import HexController from 'controllers/hex_controller';

export default class extends HexController {
  static targets = ['condition'];

  connect() {
    setTimeout(_ => {
      this.conditionParameterChanged();
    }, 100);
  }

  targetController(target) {
    return target['ms--condition-form'];
  }

  conditionParameterChanged() {
    const usedParameters = new Set();
    this.conditionTargets.forEach(conditionEl => {
      usedParameters.add(this.targetController(conditionEl).parameterIdValue);
    });
    this.updateWithUsedParameters(usedParameters);
  }

  updateWithUsedParameters(usedParameters) {
    this.conditionTargets.forEach(conditionEl => {
      this.targetController(conditionEl).updateWithUsedParameters(usedParameters);
    });
  }

  conditionTargetConnected(target) {
    setTimeout(_ => {
      const usedParameters = new Set();
      this.conditionTargets.forEach(conditionEl => {
        if (conditionEl !== target) {
          usedParameters.add(this.targetController(conditionEl).parameterIdValue);
        }
      });
      this.updateWithUsedParameters(usedParameters)
    }, 100);
  }
}
